/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";
import ServicePath from "@/core/ServicePath";

export default class OptometryPendingService extends MainService {
  static listAllPagination(params) {
    return this.postSEC(ServiceConstant.OPTOMETRY_LISTALL_PAGINATION, params);
  }
  static get(params) {
    return this.postSEC(ServiceConstant.OPTOMETRY_GET, params);
  }
  static add(params) {
    return this.postSEC(ServiceConstant.OPTOMETRY_ADD, params);
  }
  static pdf(params) {
    return this.postPDFSEC(ServicePath.OPTOMETRY_PDF, params);
  }
}
